module.exports = __webpack_public_path__ + "img/converse-details4.26bd4ed6.png";